const metadataTimeoutMilliseconds = 10000

export const readAudioDurationSeconds = (file: File): Promise<number | null> =>
  new Promise(resolve => {
    const objectUrl = URL.createObjectURL(file)
    const audio = document.createElement('audio')
    audio.preload = 'metadata'
    let settled = false
    const finish = (durationSeconds: number | null) => {
      if (settled) {
        return
      }
      settled = true
      window.clearTimeout(timeoutHandle)
      audio.removeAttribute('src')
      audio.load()
      URL.revokeObjectURL(objectUrl)
      resolve(durationSeconds)
    }
    const timeoutHandle = window.setTimeout(() => finish(null), metadataTimeoutMilliseconds)
    audio.onloadedmetadata = () => finish(Number.isFinite(audio.duration) ? audio.duration : null)
    audio.onerror = () => finish(null)
    audio.src = objectUrl
  })
